import html2pdf from 'html2pdf.js';
import { renderToStaticMarkup } from 'react-dom/server';
import Button from 'components/Button';
import WhiteDefaultLogo from 'images/Inspiretec_white.png';
import QuotePdfTemplate from '../quotePdfTemplate/QuotePdfTemplate';
import {
  RGB_PRIMARY_COLOR,
  RGB_SECONDARY_COLOR,
  RGB_WHITE,
} from '../quotePdfTemplate/styleConstants';
import { styleReset } from '../quotePdfTemplate/styleReset';

const MARGIN_BOTTOM = 0.6;
const MARGIN_TOP = 0.5;
const MARGIN_LEFT = 0.5;

const addHeader = (pdf) => {
  if (!pdf) {
    return;
  }

  pdf.setDrawColor(...RGB_SECONDARY_COLOR);
  pdf.setFillColor(...RGB_SECONDARY_COLOR);
  pdf.rect(0, 0, pdf.internal.pageSize.getWidth(), MARGIN_TOP, 'FD');
  const imageTest = new Image();
  imageTest.src = WhiteDefaultLogo;
  pdf.addImage(
    imageTest,
    'PNG',
    pdf.internal.pageSize.getWidth() / 2 - MARGIN_TOP,
    0.1,
    0,
    0.4,
  );
};

const addFooter = (pdf) => {
  if (!pdf) {
    return;
  }

  pdf.setDrawColor(...RGB_PRIMARY_COLOR);
  pdf.setFillColor(...RGB_PRIMARY_COLOR);
  pdf.rect(
    0,
    pdf.internal.pageSize.getHeight() - MARGIN_BOTTOM,
    pdf.internal.pageSize.getWidth(),
    MARGIN_BOTTOM,
    'FD',
  );

  const imageTest = new Image();
  imageTest.src = WhiteDefaultLogo;
  pdf.addImage(
    imageTest,
    'PNG',
    pdf.internal.pageSize.getWidth() - 1.75,
    pdf.internal.pageSize.getHeight() - 0.55,
    0,
    0.4,
  );

  pdf.setFontSize(10);
  pdf.setTextColor(...RGB_WHITE);

  pdf.text(
    'Contact Number: +44 123456567',
    MARGIN_LEFT,
    pdf.internal.pageSize.getHeight() - 0.5,
  );

  pdf.text(
    'Email address: travel@suntravel.co.uk',
    MARGIN_LEFT,
    pdf.internal.pageSize.getHeight() - 0.3,
  );

  const BranchFinderText = 'Branch finder';
  pdf.textWithLink(
    BranchFinderText,
    MARGIN_LEFT,
    pdf.internal.pageSize.getHeight() - 0.1,
    {
      url: 'http://www.google.com',
    },
  );

  const textWidth = pdf.getTextWidth(BranchFinderText);
  pdf.setDrawColor(...RGB_WHITE);
  pdf.setFillColor(...RGB_WHITE);
  pdf.setLineWidth(0.01);
  pdf.line(
    MARGIN_LEFT,
    pdf.internal.pageSize.getHeight() - 0.05,
    MARGIN_LEFT + textWidth,
    pdf.internal.pageSize.getHeight() - 0.05,
  );
};

const viewAsPDF = (reference = '') => {
  const quoteReference = reference ? `_${reference}` : '';

  html2pdf()
    .from(
      `<html><style>${styleReset}</style> ${renderToStaticMarkup(
        <QuotePdfTemplate />,
      )}</html>`,
      'string',
    )
    .set({
      margin: [MARGIN_TOP + 0.06, 0, MARGIN_BOTTOM + 0.015, 0],
      jsPDF: { unit: 'in' },
      html2canvas: { x: 0, y: 0 },
      pagebreak: { mode: ['avoid-all'] },
    })
    .toPdf()
    .get('pdf')
    .then((pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i += 1) {
        pdf.setPage(i);

        addHeader(pdf);
        addFooter(pdf);
      }
    })
    .save(`Quote${quoteReference}`)
    .output('dataurlnewwindow');
};

export default function DownloadItinerary({ className = '', reference = '' }) {
  return (
    <div
      className={`${className} border-2 border-secondary rounded-xl mb-[2em] hidden`}
    >
      <div className="flex p-4 flex-col xs:flex-row">
        <div className="grow">
          <p className="text-primary text-xl font-bold pb-2">
            Download your detailed itinerary
          </p>
          <p>
            Raesent volutpat diam tellus, et lobortis lacus rhoncus ac.
            Suspendisse in arcu sit amet elit porta vehicula quis nec velit.{' '}
          </p>
        </div>
        <div className="mt-3 xs:[mt-0]">
          <Button
            className="w-[13rem] mt-2"
            label="Download itinerary"
            onClick={() => viewAsPDF(reference)}
          />
        </div>
      </div>
    </div>
  );
}
